import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StoneCutForm from '../../../../components/masters/stoneAttribute/stoneCut/StoneCutForm';
import StoneCutTable from '../../../../components/masters/stoneAttribute/stoneCut/StoneCutTable';
import { fetchStoneCuts, addStoneCut, updateStoneCut, deleteStoneCut, setStoneCutEdit, clearStoneCutEdit } from '../../../../redux/actions/masters/stoneAttribute/stoneCut/stoneCutAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginRight: 0,
};
const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .stone-cut-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .stone-cut-form, .stone-cut-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const StoneCutPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingStoneCut, formSuccess, formError } = useSelector(state => state.stoneCut || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchStoneCuts());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearStoneCutEdit());
  };

  const handleSubmit = async (form) => {
    if (editingStoneCut && editingStoneCut.stonecut_id) {
      await dispatch(updateStoneCut(editingStoneCut.stonecut_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addStoneCut(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (stoneCut) => {
    dispatch(setStoneCutEdit(stoneCut));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteStoneCut(id));
  };

  const handleCancel = () => {
    dispatch(clearStoneCutEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      sc => sc.stonecut_code === code && (!excludeId || sc.stone_cut_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={{ ...containerStyle, className: 'stone-cut-flex' }}>
        <div style={{ ...tableContainer, className: 'stone-cut-table' }}>
          <StoneCutTable
            onNew={handleFormReset}
          />
        </div>
        <div style={{ ...formContainer, className: 'stone-cut-form' }}>
          <StoneCutForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingStoneCut={editingStoneCut}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default StoneCutPage; 